import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { heroChips, heroTrust } from '../data/hero';
export function Hero() {
  return <header className="bg-radial-glow relative overflow-hidden" data-id="element-85" data-mp="9ktd9lkk7ywp">
      <div className="mx-auto max-w-4xl px-5 pb-6 pt-6 text-center sm:pt-16" data-id="element-86" data-mp="9lbkfd8rfxje">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="text-[10px] font-extrabold uppercase tracking-[0.25em] text-plata" data-id="element-87" data-mp="4mrxpamcehpz">
          🏆 SIGMA SMART™
        </motion.p>

        <p className="mx-auto mt-3 max-w-2xl font-display text-[22px] font-bold leading-tight text-white sm:text-[30px]" data-id="element-88" data-mp="sai3j1dgur5q">
          Recuperá el control en 7 días y tomá decisiones con cabeza
        </p>

        <motion.h1 initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="pb-1 pt-3 font-display text-[26px] font-extrabold tracking-tight text-rojo-soft sm:text-5xl" data-id="element-89" data-mp="3d2lapfhgtb2a">
          CÓDIGO INFIDELIDAD™
        </motion.h1>
        <p className="pb-4 font-display text-sm font-bold uppercase tracking-[0.3em] text-plata-deep sm:text-base" data-id="element-90" data-mp="3o6u8lem7yzf1">
          El Manual de los 7 Días
        </p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} className="relative mx-auto w-full max-w-md" data-id="element-91" data-mp="3e8msexzr8le3">
          <div className="absolute inset-0 -z-10 mx-auto h-64 w-64 translate-y-6 rounded-full bg-rojo/25 blur-3xl" aria-hidden="true" data-id="element-92" data-mp="35aasu6gwud9i" />
          <img src="https://cdn.magicpatterns.com/uploads/7JVcg1Z7AJHUxRGRNtqs2q/ChatGPT_Image_9_ago_2026,_15_10_17.png" alt="Código Infidelidad — El Manual de los 7 Días: 12 tomos y 5 bonos en formato digital" className="animate-floaty mx-auto h-[300px] w-[300px] max-w-full rounded-2xl object-contain" data-id="element-93" data-mp="2vi50gvmqxtts" />
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.05
      }} className="mt-4 text-xs font-semibold uppercase tracking-[0.18em] text-white/50" data-id="element-94" data-mp="nbl58stuaue5">
          El sistema N°1 para sobrevivir una infidelidad sin destruir tu vida
        </motion.p>

        <div className="mt-8 flex flex-col items-center" data-id="element-95" data-mp="1azkv7qjbugro">
          <CTAButton href="#value" data-id="element-96" data-mp="1622jjsdxdnfz">Ver la oferta</CTAButton>

          <p className="mx-auto mt-4 max-w-2xl text-[14px] text-white/70 sm:text-lg" data-id="element-97" data-mp="162lyr1c6xxqb">
            Todo lo que necesitás para frenar el caos, proteger tu mente, obtener la verdad y tomar
            la decisión más importante de tu vida. Sin improvisar. Sin errores fatales. Sin perder
            tu dignidad en el intento.
          </p>

          <motion.h2 initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="mx-auto mt-4 max-w-2xl text-[16px] font-bold text-plata sm:text-xl" data-id="element-98" data-mp="3hrllakmueba1">
            Shock · Evidencia · Confrontación · Decisión · Reconstrucción
          </motion.h2>

          <div className="mt-6 flex flex-wrap justify-center gap-2.5" data-id="element-99" data-mp="268g468c4awp9">
            {heroChips.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5 rounded-full border border-white/10 bg-white/5 px-3.5 py-1.5 text-xs font-semibold text-white/80" data-id="element-100" data-mp="2b2k6geafugk0">
                <Icon className="h-3.5 w-3.5 text-rojo-soft" data-id="element-101" data-mp="2ozz426auhun2" />
                {label}
              </span>)}
          </div>

          <p className="mt-4 text-sm font-semibold text-white/50" data-id="element-102" data-mp="2tz1xethgqcf7">
            12 Tomos · 5 Bonos · +100 páginas — Todo resuelto.
          </p>
        </div>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs font-medium text-white/50" data-id="element-103" data-mp="zlausdxjwst9">
          {heroTrust.map(({
          icon: Icon,
          label
        }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-104" data-mp="3vhp59x1jccpz">
              <Icon className="h-4 w-4 text-plata" data-id="element-105" data-mp="3vhf9ttxq1dcw" />
              {label}
            </span>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.05
      }} className="mt-5 inline-flex items-center gap-2 rounded-full border border-rojo/50 bg-rojo/10 px-4 py-1.5 text-xs font-bold uppercase tracking-wide text-rojo-soft" data-id="element-106" data-mp="e77grka8v5gf">
          🔥 Oferta de lanzamiento cierra pronto · No vuelve a este precio
        </motion.div>
      </div>
    </header>;
}